import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import RandomContent from '../Components/RandomContent';
import { handleDownload } from '../Conversion/Base64';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { base64ToImageFAQ } from '../Seo/faqSchemas';

const Base64ToImage = () => {
  const [inputData, setInputData] = useState('');
  const [imageSrc, setImageSrc] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [pageContent, setpageContent] = useState('');

  const location = useLocation();
  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    setInputData('');
    setImageSrc('');
    setIsError(false);
    GetPageContent();
  }, []);

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setpageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const handleConversion = () => {
    if (inputData.trim() === '') {
      toast.error('Please enter a valid Base64 string');
      setIsError(true);
      return;
    }

    try {
      const isValidBase64 = inputData.startsWith('data:image/') && inputData.includes(';base64,');
      if (!isValidBase64) {
        toast.error('Invalid Base64 image string');
        setIsError(true);
        return;
      }
      setImageSrc(inputData);
      setIsError(false);
      toast.success('Image converted successfully');
    } catch (err) {
      setIsError(true);
      toast.error('Error converting Base64 to image');
    }
  };

  const handleDownloadWrapper = () => handleDownload(imageSrc, toast);

  return (
    <>
      <div>
        <Header />

        <Helmet>
          <title>{pageContent?.section1header || "Free Base64 to Image Converter - Preview & Download - Data Beautifier"}</title>
          <meta name="description" content="Convert Base64 code into images effortlessly. Paste your string, preview instantly, and download as a file. Reliable and fast solution." />
          <link rel="canonical" href={`https://databeautifier.com/${paramlink}`} />
          <meta property="og:title" content={pageContent?.section1header} />
          <meta property="og:url" content={`https://databeautifier.com/${paramlink}`} />
          <script type="application/ld+json">
            {JSON.stringify(base64ToImageFAQ)}
          </script>
        </Helmet>
        
        <RandomContent />

        {/* Page Intro */}
        <div className="blog-area">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div
                  className="single-blog-inner"
                  data-aos="fade-up"
                  data-aos-duration="2800"
                >
                  <div className="details">
                    <h4>
                      <a href="#">{pageContent?.section1header}</a>
                    </h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          pageContent?.section1text &&
                            pageContent.section1text.trim() !== ""
                            ? pageContent.section1text
                            : `Convert Base64 code into images effortlessly with Data Beautifier's Free Base64 to Image Conversion Tool. 
                      Paste your Base64 string, preview the image instantly, and download it in one click. 
                      A reliable, fast, and user-friendly solution for developers and designers.`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Input / Button / Output Section */}
        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">

              {/* Input Box */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="thumb">
                    <Inputs
                      value={inputData}
                      setValue={(val) => {
                        setInputData(val);
                        setIsError(false);
                      }}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={isError}
                      lineCol={inputLnCol}
                      setLineCol={setInputLnCol}
                      readOnly={false}
                      idPrefix="input"
                      placeholder="Paste Base64 image string here"
                    />
                  </div>
                </div>
              </div>

              {/* Convert Button */}
              <div
                className="w3-col m2"
                style={{
                  flex: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <button
                  className="default-btn icon four"
                  onClick={handleConversion}
                  disabled={!inputData.trim()}
                >
                  <i className="ri-exchange-line"></i>
                  Convert
                </button>
              </div>

              {/* Output Box - Only Image */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                  <div
                    className="thumb"
                    style={{
                      minHeight: '300px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '15px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      background: '#fafafa',
                    }}
                  >
                    {imageSrc ? (
                      <>
                        <img
                          src={imageSrc}
                          alt="Converted Preview"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '250px',
                            borderRadius: '8px',
                            marginBottom: '15px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            objectFit: 'contain',
                          }}
                        />
                        <button
                          onClick={handleDownloadWrapper}
                          className="default-btn icon four"
                          style={{ backgroundColor: '#E64D25', borderColor: '#E64D25' }}
                        >
                          <i className="ri-download-line"></i> Download
                        </button>
                      </>
                    ) : (
                      <p style={{ color: '#999', fontStyle: 'italic', textAlign: 'center' }}>
                        Image preview will appear here after conversion.
                      </p>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Section 2 Below Boxes */}
        {pageContent?.section2text &&
          pageContent.section2text.trim() !== "" && (
            <div className="blog-area">
              <div className="container-block-fluid">
                <div className="row justify-content-center">
                  <div className="full-col col-lg-12 col-md-12">
                    <div
                      className="single-blog-inner"
                      data-aos="fade-up"
                      data-aos-duration="2800"
                    >
                      <div className="details">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: pageContent.section2text,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* Section 3 Below Boxes */}
        {pageContent?.section3text &&
          pageContent.section3text.trim() !== "" && (
            <div className="blog-area">
              <div className="container-block-fluid">
                <div className="row justify-content-center">
                  <div className="full-col col-lg-12 col-md-12">
                    <div
                      className="single-blog-inner"
                      data-aos="fade-up"
                      data-aos-duration="2800"
                    >
                      <div className="details">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: pageContent.section3text,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

      </div>

      <Footer />
    </>
  );
};

export default Base64ToImage;
